module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dLyxu"))).then(() => parcelRequire('d0iPb'));